module.exports = __webpack_public_path__ + "static/media/search.c0c67ad2.svg";